<template>
  <div class="content-input" v-if="field">
    <input-media :open="false" v-if="field.type.includes('Media')"
      v-model="inputValue"/>

    <input-rich-text key="MainEditor" v-else-if="field.type.includes('RichText')"
      v-model="inputValue"/>

    <el-select v-else-if="field.type.includes('String')
        && field.config.validations.find(v => Object.keys(v).includes('enum'))"
      v-model="inputValue"
      placeholder="Choisir">
      <el-option
        v-for="item in field.config.validations.find(v => Object.keys(v).includes('enum')).enum"
        :key="item.value"
        :label="item.label"
        :value="item.value">
      </el-option>
    </el-select>


    <input-document v-else-if="field.type.includes('Document')"
      v-model="inputValue"
      :entityId="field.config.validations[0].documentType[0]"
      :spaceId="$route.params.spaceId" :lang="lang"/>

    <input-delta-text v-else-if="field.type.includes('DeltaText')"
      v-model="inputValue"/>

    <input-structured-text v-else-if="field.type.includes('StructuredText')"
      :config="field.config"
      v-model="inputValue"/>

    <el-input v-else-if="field.type.includes('Text')"
      type="textarea" :rows="4"
      :placeholder="field.label"
      v-model="inputValue">
    </el-input>

    <div class="object" v-else-if="field.type.includes('Object')">
      <div class="object-element" v-for="objectField in field.config.properties" :key="`${field.name}-${objectField.name}`">
        <label>{{ objectField.label }}</label>
        <content-input v-if="inputValue" v-model="inputValue[objectField.name]" :field="objectField"/>
      </div>
    </div>

    <el-input v-else
      :placeholder="field.label"
      v-model="inputValue"/>
  </div>
</template>

<script>
import InputMedia from '@/components/forms/InputMedia.vue';
import InputRichText from '@/components/forms/InputRichText.vue';
import InputStructuredText from '@/components/forms/InputStructuredText.vue';
import InputDocument from '@/components/forms/InputDocument.vue';
import InputDeltaText from '@/components/forms/InputDeltaText.vue';
import ContentInput from '@/components/content/ContentInput.vue';

export default {
  name: 'content-input',
  props: ['value', 'field'],
  components: {
    InputMedia,
    InputRichText,
    InputStructuredText,
    InputDocument,
    InputDeltaText,
    ContentInput,
  },
  data() {
    return {
      inputValue: null,
    };
  },
  mounted() {
    this.init();
  },
  watch: {
    value: 'init',
    inputValue: 'save',
  },
  methods: {
    init() {
      if (this.inputValue !== this.value) this.inputValue = this.value;
    },
    save() {
      if (this.inputValue !== this.value) this.$emit('input', this.inputValue);
    },
  },
};
</script>

<style lang="sass">
.content-input
  .input-media
    .add
      font-size: 0.9rem
    &.empty
      .add
        color: #ff3c48

  &.empty
    input
      border-color: #ff3c48

</style>

